export enum ServiceTypesEnum {
        Scheduled = 2099,
        TwentyFourhours = 2100,
        Disabled = 2101,
}
